function getBrandIdentifier(route) {
  return { brandIdentifier: Number(route.query.brandIdentifier) };
}

export default [
  {
    name: 'chatbot_edit',
    path: '/chatbot/chatbot_edit',
    meta: {
      title: '챗봇 시나리오 에디터',
      requiresBrandKey: true
    },
    component: () => import(/* webpackChunkName: "ChatbotEdit" */ '@/components/menus/chatbot/chatbot_edit'), // 설정 -> 톡 채널 설정 -> 챗봇 시나리오 에디터
    props: getBrandIdentifier
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/chatbot.js